

import { IField } from "@esri/arcgis-rest-feature-layer";
import { ILayerDefinition } from "@esri/arcgis-rest-feature-layer";
import ConfigService from "./configService";
import ContextService from "./contextService";

export default class Utils {
 
  /**
     * Set a state value
     * @param prop 
     * @param value 
     */
  public static setStateValue(prop: string, value: any, state: Object, setState: Function ) {
    const obj: any = {...state};
    obj[prop] = value;
    setState(obj);
  }

  /**
   * Create query operational layer url
   * @param index 
   * @returns 
   */
  public static getOpLayerQuery(index: number): string {
    return index >= 0 ? `${ConfigService.getConfig().agol?.operationalLayers.baseURL}/${index}` : '';
  }

  public static getReportLayerQuery(index: number): string {
    return index >= 0 ? `${ConfigService.getConfig().agol?.operationalLayers.consultURL}/${index}` : '';
  }
  
  /**
   * Create query gadm layer url
   * @param index 
   * @returns 
   */
   public static getGADMLayerQuery(index: number): string {
    return index >= 0 ? `${ConfigService.getConfig().agol?.gadmLayers.baseURL}/${index}` : '';
  }

  /**
   * Create query reference table url
   * @param index 
   * @returns 
   */
   public static getReferenceTableQuery(index: number): string {
    return index >= 0 ? `${ConfigService.getConfig().agol?.referenceTables.baseURL}/${index}` : '';
  }

  // /**
  //  * Create query Private sectorereference table url
  //  * @param index 
  //  * @returns 
  //  */
  // public static getfilterReferenceTableQuery(index: number): string {
  //   return index >= 0 ? `${ConfigService.getConfig().agol?.referenceTables.baseURL}/${index}` : '';
  // }

  /**
   * Validate email
   * @param email 
   * @returns 
   */
  public static validateMail(email: string): boolean {
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ) !== null;
  }

  /**
   * Check string is empty
   * @param str
   * @returns
   */
  public static isEmpty(val: any): boolean {
    return [undefined, null, '', '-999'].indexOf(val) !== -1;
  }

  /**
   * replace white space from content editor
   * @param str
   * @returns
   */
  public static trimWhiteSpace(val: any) {
    let contentDtl = ''; 
    if(val != null && val.length > 0) 
    {      
      contentDtl = val.replaceAll("\"", "");
    }
    contentDtl = contentDtl.trim().replace(/\\r|\\n/g,'<br>').replace(/<br><br>/g,"<br>");
    return contentDtl;
  }

  /**
   * remove html tags
   * @param str
   * @returns
   */
  public static removeHTMLTag(val: any) {
    const regex = /(<([^>]+)>)/gi;
    let result: any = '';    
    if(val != null && val != undefined)
    {
      val = val.toString();
      result = val.replace(regex, ""); 
      result =result.replace('&nbsp;',' ');
    }
        
    return result;
  }

  /**
   * format link on retrive
   * @param str
   * @returns
   */
  public static fetchLinkFormat(val: any) {    
    let result: any = '';    
    if(val != null && val != undefined)
    {
      val = val.toString();
      result = val.replaceAll('%3D\\','='); 
      result =result.replace('&nbsp;','');
    }
        
    return result;
  }

  /**
   * format link on save
   * @param str
   * @returns
   */
  public static saveLinkFormat(val: any) {    
    let result: any = '';    
    if(val != null && val != undefined)
    {
      val = val.toString();
      result = val.replaceAll('=','%3D'); 
      result =result.replace('&nbsp;','');
    }
        
    return result;
  }

  public static addSpace (val: any) {
    let result: any = '';    
    if(val != null && val != undefined)
    {
      val = val.toString();
      result = val.replace(",", ", "); 
    }
        
    return result;
  }

  /**
   * Get field info
   * @param str
   * @returns
   */
   public static getFieldInfos(layerIndex: number, name: string): IField | undefined {
    
    if(ContextService.getInstance().layersInfos[layerIndex]) {
      const layerField: ILayerDefinition = ContextService.getInstance().layersInfos[layerIndex]
      const field: IField | undefined = layerField.fields?.find( (f: IField) => f.name === name );

      if (field) {
        return field;
      }
    }

    return undefined;
  }

  /**
   * Check required fields
   * @param str
   * @returns
   */
   public static checkRequiredFields(fields: string[], attributes: any): boolean {
    let isOK = true;

    if (fields) {
      fields.forEach( (field: string) => {
        if(field in attributes) {
          // Special case : success factors monitoring : information / mrv_system attributes["mrv_system"]
          if(field === "information" && "mrv_system" in attributes) {
            if(attributes["mrv_system"]) {
              isOK = isOK && !Utils.isEmpty(attributes[field]);
            }
          } else {
            isOK = isOK && !Utils.isEmpty(attributes[field]);
          }
        } else {
          isOK = false;
        }

        if (!isOK) {
          return false;
        }
      });
    }

    return isOK;
  }
  
  /**
   * Check if a field is required
   * @param str
   * @returns
   */
  public static isRequiredField(fields: string[], field: string): boolean {
    return fields && fields.indexOf(field) !== -1;
  }

  /**
   * Prevent negative values in a number input
   * @param e
   */
  public static preventNegativeValue (e: any) {
    if (isNaN(e.target.value) || Number(e.target.value) < 0) {
      e.preventDefault();
      e.target.value = 0;
    } else {
      e.target.value = Number(e.target.value);
    }
  }

  /**
   * Prevent negative values in a number (float) input
   * @param e
   */
   public static preventNegativeValueFloat (e: any) {
    if (!isNaN(e.target.value) && Number(e.target.value) < 0) {
      e.target.value = Math.abs(Number(e.target.value));
    }
  }

  /**
   * Validate year
   * @param e
   */
   public static validateYear (e: any) {
    if (isNaN(e.target.value) || Number(e.target.value) < 0) {
      e.preventDefault();
      e.target.value = 1900;
    } else if(Number(e.target.value) >= 1000 && Number(e.target.value) < 1900) {
      e.target.value = 1900;
    } else if(Number(e.target.value) >= 1000 && Number(e.target.value) > 2100) {
      e.target.value = 2100;
    } else {
      e.target.value = Number(e.target.value);
    }
  }
}
